import { useMutation } from "@apollo/client";
import { useFormik } from "formik";
import { useState } from "react";
import { UPDATE_WAREHOUSE_SITE } from "../../../../../graphql/mutation/WarehouseSite";
import { Button, getInput } from "../../../../../components/ui";
import { getMutationError, getSiteOptions } from "../helpers";

const SiteDetailsForm = props => {
  const { site } = props || {};
  const [error, setError] = useState(null);
  const [updateWarehouseSite, { loading }] = useMutation(UPDATE_WAREHOUSE_SITE);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: site?.description || "",
      name: site?.name || "",
    },
    onSubmit: async values => {
      const result = await updateWarehouseSite({
        variables: {
          input: {
            id: site.id,
            description: values.description,
            name: values.name,
          },
        },
      });
      setError(getMutationError(result, "updateWarehouseSite"));
    },
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-[1fr_2fr_auto] lg:items-end">
        {getInput({ formik, label: "Site name", name: "name", type: "text" })}
        {getInput({
          formik,
          label: "Site description",
          name: "description",
          type: "text",
        })}
        <Button
          className="sm:col-span-2 lg:col-span-1"
          label={loading ? "Saving" : "Save site"}
          disabled={loading || !formik.dirty}
          onClick={formik.submitForm}
        />
      </div>
      {error && (
        <div role="alert" className="text-sm text-red-600">
          {error}
        </div>
      )}
    </div>
  );
};

const SiteHeader = props => {
  const { onSiteChange, site, siteId, warehouseSites, loading } = props || {};

  const selectorFormik = useFormik({
    enableReinitialize: true,
    initialValues: { siteId },
  });

  return (
    <div className="flex flex-col gap-6 pb-8">
      <div className="flex items-end gap-8">
        <div className="w-full max-w-96">
          {getInput({
            formik: selectorFormik,
            isLoading: loading,
            isNullable: false,
            label: "Site",
            name: "siteId",
            onChange: onSiteChange,
            options: getSiteOptions(warehouseSites),
            placeholder: "Choose a site",
            type: "multi-select",
          })}
        </div>
      </div>
      {site && <SiteDetailsForm site={site} />}
    </div>
  );
};

export default SiteHeader;
